import React from 'react';
import { useSelector } from 'react-redux';

import { useOnMountDataRequest } from 'common/hooks';
import LoadingPage from 'common/components/LoadingPage';
import NextRewardRateCard from '../NextRewardRateCard';
import BalanceCard from '../BalanceCard';
import UnlockScheduleCard from '../UnlockScheduleCard';
import { selectors, actions } from '../../index';

import styles from './index.module.css';

const RewardsContent = () => {
  const { isMounting } = useOnMountDataRequest(actions.rewardsRequest);
  const isFetchingRewards = useSelector(selectors.isFetchingRewards);
  const rewardsData = useSelector(selectors.rewardsData);

  if (isMounting || isFetchingRewards || !rewardsData) {
    return <LoadingPage />;
  }

  return (
    <div className={styles.root}>
      <div className={styles.leftColumn}>
        <NextRewardRateCard
          rate={rewardsData.nextRewardRate.rate}
          description={rewardsData.nextRewardRate.description}
        />
        <BalanceCard balance={rewardsData.balance} />
      </div>
      <div className={styles.rightColumn}>
        <UnlockScheduleCard schedule={rewardsData.schedule} />
      </div>
    </div>
  );
};

export default RewardsContent;
